import { useMemo } from "react";

import { useComment } from "../../../../../../../reactQuery/cards";
import { useHistory, useWorklog } from "../../../../../../../reactQuery/worklog";
import { getResponseData } from "../../../../../../../reactQuery/response";
import { sortByDateDescending } from "../../hooks/commentUtils";

const HISTORY_TYPES = ["change_status", "card_assign", "create_card", "change_board"];

export function useAllDetailItems(cardId) {
  const {
    isLoading: isCommentLoading,
    comment,
  } = useComment(cardId);
  const { isLoading: isHistoryLoading, history } = useHistory(cardId);
  const {
    isLoading: isWorklogLoading,
    worklog,
  } = useWorklog(cardId);

  const comments = useMemo(
    () =>
      getResponseData(comment, []).map((item) => ({
        ...item,
        objType: "comment",
        consolidateTime: item.comment_time,
      })),
    [comment]
  );

  const historys = useMemo(
    () =>
      getResponseData(history, [])
        .filter((item) => HISTORY_TYPES.includes(item?.response_object?.event_type))
        .map((item) => ({
          ...item,
          objType: "history",
          consolidateTime: item.at_time,
        })),
    [history]
  );

  const worklogs = useMemo(
    () =>
      getResponseData(worklog, []).map((item) => ({
        ...item,
        objType: "worklog",
        consolidateTime: item.worklog_time,
      })),
    [worklog]
  );

  const items = useMemo(
    () => sortByDateDescending([...historys, ...worklogs, ...comments], "consolidateTime"),
    [comments, historys, worklogs]
  );

  return {
    isLoading: isCommentLoading || isHistoryLoading || isWorklogLoading,
    items,
  };
}
